import styled from "styled-components";
import { COLORS } from "styles/colors";
import { FLEX } from "styles/flex";
import * as mediaQuery from "components/MediaQuery";
import {
  collapsedSidebarWidth,
  discollapsedSidebarWidth,
} from "components/blocks/sidenav/SideNavBarStyled";
import { calcRem } from "styles/theme";

export const WarningContainer = styled.div`
  width: 100%;
  background: ${COLORS.RED};
  color: ${COLORS.WHITE};
  font-size: ${calcRem(14)};
  padding: 6px 8px;
  text-align: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
`;

export const Container = styled.div<{ noticeHeight: number }>`
  width: 100%;
  height: max-content;
  background-color: ${({ theme }) =>
    theme.value === "light" ? "transparent" : COLORS.PRIMARY2};

  ${mediaQuery.isDefault} {
    ${FLEX.FlexEndStart};
    min-height: 100vh;
  }
  ${mediaQuery.isMobile} {
    ${FLEX.FlexStartCenter};
    flex-direction: column;
    position: relative;
    height: ${({ noticeHeight }) =>
      `
    calc(100dvh - ${noticeHeight}px);
  `};
    min-height: -webkit-fill-available;
  }
`;

export const ContentsContainer = styled.main<{
  isVideoShare: boolean;
  isOpen: boolean;
  isDashboard: boolean;
}>`
  height: 100%;
  width: 100%;
  position: relative;
  width: calc(
    100% -
      ${({ isOpen }) =>
        isOpen ? discollapsedSidebarWidth : collapsedSidebarWidth}px
  );

  ${mediaQuery.isDefault} {
    width: calc(100% - 80px);
    ${({ isDashboard, theme }) =>
      isDashboard &&
      `
    background-color: ${theme.value === "light" && "#F1F1F1"}
    `}
  }
  ${mediaQuery.isTablet} {
    width: calc(100vw - ${discollapsedSidebarWidth}px);
  }
  ${mediaQuery.isMobile} {
    width: 100vw;
    ${({ isDashboard }) =>
      isDashboard &&
      `
        padding-top: 50px;
      `}
  }

  ${({ isVideoShare, isOpen }) =>
    isVideoShare &&
    (isOpen
      ? `width: calc(100vw - ${discollapsedSidebarWidth}px);`
      : `width: calc(100vw - ${collapsedSidebarWidth}px);`)}
`;

export const Layout = styled.div<{
  noticeHeight: number;
  isCollapsed: boolean;
}>`
  display: flex;
  height: ${({ noticeHeight }) => `
    calc(100dvh - ${noticeHeight}px);
  `};
  min-height: -webkit-fill-available;
  position: relative;

  .pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu .pro-inner-list-item {
    transition-property: none !important;
  }
  .ps-sidebar-root {
    width: ${({ isCollapsed }) =>
      isCollapsed
        ? discollapsedSidebarWidth
        : collapsedSidebarWidth}px !important;
    min-width: ${({ isCollapsed }) =>
      isCollapsed
        ? discollapsedSidebarWidth
        : collapsedSidebarWidth}px !important;
  }
  ${mediaQuery.isMobile} {
    .ps-sidebar-root {
      width: ${({ isCollapsed }) => (isCollapsed ? 0 : "100vw")} !important;
      min-width: ${({ isCollapsed }) => (isCollapsed ? 0 : "100vw")} !important;
    }
  }
`;
